"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { isSafeHref } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type LogosProps = Extract<CampaignPageSection, {
  type: "logos";
}>;

/** Baris logo partner: grayscale, kembali berwarna saat hover. */
export default function LogosSection(t0) {
  const $ = _c(15);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style || $[3] !== section.heading) {
    t2 = section.heading && <p className="text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</p>;
    $[2] = section.custom_style;
    $[3] = section.heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== section.items) {
    t3 = section.items.map(_temp);
    $[5] = section.items;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-6">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto max-w-6xl px-5">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <section className="bg-white py-10 md:py-14" style={t1}>{t5}</section>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(item, i) {
  const logo = <SafeImage src={item.image_url} alt={item.alt ?? "Logo partner"} loading="lazy" className="h-9 w-auto max-w-[140px] object-contain grayscale opacity-60 transition-all duration-200 hover:grayscale-0 hover:opacity-100 md:h-10" />;
  return item.href && isSafeHref(item.href) ? <a key={i} href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.alt ?? "Logo partner"}>{logo}</a> : <span key={i}>{logo}</span>;
}